export const AI_IMAGE_GENERATOR_CONSTANTS = {
  IMAGE_ACCEPT_TYPES: 'image/*',
  PHOTO_SIZE: 320,
  CANVAS_SIZE: 320,
  SOURCE_CANVAS_SIZE: 320,
  SOURCE_CARD_WIDTH: 360,
  SOURCE_CARD_HEIGHT: 492,
  MODAL_SIZE: '100vw',
  MODAL_HEIGHT: '100dvh',
  GENERATE_IMAGE_MAX_SIZE: 1024,
  GENERATE_IMAGE_JPEG_QUALITY: 0.85,
  GENERATE_POLL_INTERVAL_MS: 3000,
  GENERATE_POLL_MAX_ATTEMPTS: 200,
  GENERATE_STATUS_TRANSIENT_RETRIES: 3,
  IMAGE_MAX_WIDTH: 300,
  IMAGE_HEIGHT: 300,
  COLUMN_BACKGROUND: 'rgba(226, 226, 233, 1)',
  BORDER_RADIUS: '28px',
  SUCCESS_BORDER_COLOR: 'rgba(34, 195, 75, 1)',
  RESULT_BORDER_COLOR: 'rgba(200, 200, 213, 1)',
  ERROR_BORDER_COLOR: '#FF7870',
  PROMPT_SELECT_LIST_HEIGHT_MAX: 300,
} as const;

const dashedBorderBackground = (strokeColor: string) => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" preserveAspectRatio="none"><rect style="x:0.5px;y:0.5px;width:calc(100% - 1px);height:calc(100% - 1px)" rx="28" ry="28" stroke="${strokeColor}" stroke-width="1" stroke-dasharray="6 4" vector-effect="non-scaling-stroke"/></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
};

const dashedBorder = (strokeColor: string) =>
  ({
    position: 'relative' as const,
    overflow: 'hidden',
    border: 'none',
    '&::after': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: AI_IMAGE_GENERATOR_CONSTANTS.BORDER_RADIUS,
      pointerEvents: 'none',
      backgroundImage: dashedBorderBackground(strokeColor),
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
    },
  }) as const;

export const dashedBorderSx = {
  result: dashedBorder(AI_IMAGE_GENERATOR_CONSTANTS.RESULT_BORDER_COLOR),
  success: dashedBorder(AI_IMAGE_GENERATOR_CONSTANTS.SUCCESS_BORDER_COLOR),
  error: dashedBorder(AI_IMAGE_GENERATOR_CONSTANTS.ERROR_BORDER_COLOR),
} as const;

export const IMAGE_STYLES = {
  container: {
    width: '100%',
    maxWidth: 300,
    height: 300,
    objectFit: 'cover' as const,
    borderRadius: 1,
  },
  placeholder: {
    width: '100%',
    maxWidth: 300,
    height: 300,
    border: '2px dashed',
    borderRadius: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'gray ultra light',
  },
} as const;
